import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";
import ajaxStations from "../../util/remote/ajaxStations";
import RegisterSupplierModal from "./RegisterSupplierModal";
const ViewSuppliers = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [viewType, setViewType] = useState("table view");
  const [station_id, setstation_id] = useState(station_idd); // default
  const [stations_company_id, setStations_company_id] = useState(
    window.localStorage.getItem("FuelFy@company_id") || "" // get from localStorage
  );
  const fetchStationMotherStation = async () => {
    setLoading(true);
    try {
      const response = await ajaxStations.get_station_mother_company_id({
        station_id,
      });
      if (response.status === "OK") {
        setStations_company_id(response.details);
      } else {
        toast.error(response.message);
      }
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!stations_company_id) {
      fetchStationMotherStation();
    }
  }, [stations_company_id, station_id]);
  const fetchSuppliers = async () => {
    setLoading(true);
    const data = { stations_company_id: stations_company_id };
    const response = await ajaxSuppliers.list_supplier(data);
    if (response.status === "OK") {
      setSuppliers(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchSuppliers();
  }, [stations_company_id]);
  const toggleView = (type) => setViewType(type);
  const [register, setRegister] = useStateCallback(false);
  const handleRegister = () => {
    setRegister(false, () =>
      setRegister(<RegisterSupplierModal func={fetchSuppliers} />)
    );
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Supplier",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Fuel Suppliers"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {register}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Suppliers...
          </div>
        ) : suppliers.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Suppliers Available
          </div>
        ) : viewType === "table view" ? (
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <h6 className="card-title mb-1">Suppliers</h6>
                  <p className="text-muted card-sub-title">
                    List of registered suppliers
                  </p>
                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th> <th>Name</th> <th>Contact</th>
                          <th>Alt Contact</th> <th>Address</th> <th>Status</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {suppliers.map((supplier, index) => (
                          <tr key={supplier.id}>
                            <td>{index + 1}</td> <td>{supplier.name}</td>
                            <td>{supplier.contact}</td>
                            <td>{supplier.alt_contact}</td>
                            <td>{supplier.address}</td>
                            <td>
                              <span
                                className={`badge ${
                                  supplier.status === "1"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                              >
                                {supplier.status === "1"
                                  ? "Active"
                                  : "Inactive"}
                              </span>
                            </td>
                            <td>{supplier.created_at}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {suppliers.map((supplier) => (
              <div className="col-md-4 col-lg-3 mb-3" key={supplier.id}>
                <div
                  className="card h-100"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-1">{supplier.name}</h6>
                    <small className="d-block text-muted">
                      Contact: {supplier.contact} <br />
                      Alt Contact: {supplier.alt_contact} <br />
                      Address: {supplier.address} <br />
                      Created: {supplier.created_at}
                    </small>
                    <div className="mt-2">
                      <span
                        className={`badge px-3 py-1 ${
                          supplier.status === "1" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {supplier.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppContainer>
  );
};
export default ViewSuppliers;
